import React from "react";
import protectedImg from "../../assets/images/DeathModuleNew/protected.svg";
import "./deathDashboard.css";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";

export const PasswordListDashboard = (props) => {


  return (
    <div>
      <div className="cardHeading">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          PASSWORD LIST
          <ToolTipCreator name={"Death_List_of_Passwords"}/>
        </div>
      </div>

      <div style={{height:"10rem", display:"flex", justifyContent:"center", flexDirection:"column" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems:"center",
            fontWeight:"700",
            fontFamily:"Poppins",
            fontSize:"14px",
            flexDirection:"column"
          }}
        >
        {props.role !== "trustee" ? 
          "SECURED! We have your passwords guarded behind multiple levels of protection." : "This Information will be available you soon!"}
          <img
          src={protectedImg}
          style={{ width: "50px", height: "50px", marginTop:"8px" }}
          alt="protectedImg"
        ></img>
        </div>
    </div>
    </div>
  );
};
